/* Focus and dismiss the full/floating desktop search popover. */
(function(){'use strict';
 document.querySelectorAll('[data-tj-desktop-search]').forEach(function(d){
  d.addEventListener('toggle',function(){if(d.open){var i=d.querySelector('input[name="q"]');if(i)i.focus({preventScroll:true})}});
  d.addEventListener('keydown',function(e){if(e.key==='Escape'){d.open=false;var s=d.querySelector('summary');if(s)s.focus()}})
 });
 document.addEventListener('click',function(e){document.querySelectorAll('[data-tj-desktop-search][open]').forEach(function(d){if(!d.contains(e.target))d.open=false})});
})();